<div class="pagina mb-5 mx-auto">
    <div class="contenido">
        <ng-container documentoDinamico></ng-container>
    </div>
</div>